<template>
  <div>
    <div class="header">
      <b-alert variant="info" :show="message != null">{{message}}</b-alert>
      <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
    </div>
    <div class="container-fluid">
      <div class="p-2 border-bottom border-info">
        <h4 class="text-info font-italic">
          <strong><i class="fas fa-address-card"></i> 参加者情報</strong>
          <span class="ml-2"><b-btn size="sm" variant="info" @click="loadItems()"><i class="fas fa-sync"/> 再読込</b-btn></span>
        </h4>
        <div v-if="loading">読込中</div>
        <div v-else>
          <span v-if="!currentUserGroup.closedAt">
            <b-btn size="md" variant="warning" @click="onMeasureSet">体組成計を今すぐ測定する</b-btn>
          </span>
        </div>
      </div>
      <div class="p-2 border-bottom border-info">
        <b-link href="#bodyComposition">体組成計</b-link>
        <span class="mx-2">|</span>
        <b-link href="#others">その他測定</b-link>
        <span class="mx-2">|</span>
        <b-link href="#enquete">アンケート</b-link>
      </div>
      <b-card-group columns v-if="userSettings">
        <b-card no-body>
          <div slot="header"><i class="fas fa-user"></i> 基本情報</div>
          <b-list-group flush>
            <b-list-group-item>
              <div class="mealsTime">
                <span class="label">
                  会員番号
                </span>
                <span>
                  <span class="val">{{ userSettings.user_id }}</span>
                </span>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div class="mealsTime">
                <span class="label">
                  ID番号
                </span>
                <span>
                  <span class="val">{{ dailyEnquete.userNo }}</span>
                </span>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'heightInCentimeters'">
                <b-form-group>
                  <b-input-group prepend="身長">
                    <b-form-input
                                id="heightInCentimeters"
                                type="number"
                                size="md"
                                v-model="form.heightInCentimeters"
                                :state="validators.heightInCentimeters"
                                required
                                placeholder="cm">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editUser('heightInCentimeters')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="heightInCentimetersFeedback">
                      身長を入力してください. (90-240cm)
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    身長:
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onUserEdit('heightInCentimeters')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="userSettings.heightInCentimeters">
                    <span class="val">{{ userSettings.heightInCentimeters }}</span>
                    <span class="unit">cm</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'gender'">
                <b-form-group>
                  <span>性別: </span>
                  <b-form-radio-group id="gender"
                        buttons
                        button-variant="outline-primary"
                        v-model="form.gender"
                        required
                        :validated="validators.gender"
                        :options="genderOptions"
                        name="radiosBtnDefault">
                  </b-form-radio-group>
                  <b-btn variant="success" @click="editUser('gender')"><i class="fas fa-save"></i></b-btn>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    性別:
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onUserEdit('gender')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="userSettings.gender">
                    <span class="val">{{ userSettings.gender === '1' ? '男性' : '女性' }}</span>
                    <span class="unit"></span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div class="mealsTime">
                <span class="label">
                  年齢:
                </span>
                <span>
                  <span class="val">{{ userSettings.age }}</span>
                  <span class="unit">才</span>
                </span>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'weightAdjustmentInKilograms'">
                <b-form-group>
                  <b-input-group prepend="着衣量">
                    <b-form-input
                                id="weightAdjustmentInKilograms"
                                type="number"
                                size="md"
                                v-model="form.weightAdjustmentInKilograms"
                                :state="validators.weightAdjustmentInKilograms"
                                required
                                placeholder="kg (通常: 1.0kg)">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('heightInCentimeters')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="heightInCentimetersFeedback">
                      着衣量を入力してください. (0-10kg)
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    着衣量:
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onUserEdit('weightAdjustmentInKilograms')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="userSettings.weightAdjustmentInKilograms">
                    <span class="val">{{ userSettings.weightAdjustmentInKilograms }}</span>
                    <span class="unit">kg</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'physicalType'">
                <b-form-group>
                  <span>体型: </span>
                  <b-form-radio-group id="physicalType"
                        buttons
                        button-variant="outline-primary"
                        v-model="form.physicalType"
                        required
                        :validated="validators.physicalType"
                        :options="physicalTypeOptions"
                        name="radiosBtnDefault">
                  </b-form-radio-group>
                  <b-btn variant="success" @click="editUser('physicalType')"><i class="fas fa-save"></i></b-btn>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    体形:
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onUserEdit('physicalType')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="userSettings.physicalType">
                    <span class="val">{{ userSettings.physicalType === '2' ? 'アスリート' : '標準' }}</span>
                    <span class="unit"></span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-card no-body id="bodyComposition">
          <div slot="header"><i class="fas fa-weight"></i> 体組成計</div>
          <div>
            <div v-if="loading">読込中</div>
            <div v-else>
              <b-list-group v-if="!dailyEnquete.bodyCompositions">
                <span v-if="currentUserGroup.closedAt">
                  <b-list-group-item>
                    測定なし
                  </b-list-group-item>
                </span>
                <span v-else>
                  <b-btn size="md" variant="warning" @click="onMeasureSet">今すぐ測定する</b-btn>
                </span>
              </b-list-group>
              <b-list-group flush v-else>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      体重
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions" class="ml-auto">
                      <span class="val">{{ vv1000(bodyComposition, 'weightInGrams') }}</span>
                      <span class="unit">kg</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      体脂肪率
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv(bodyComposition, 'bodyFatInPercent') }}</span>
                      <span class="unit">%</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      脂肪量
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv1000(bodyComposition, 'bodyFatMassInGrams') }}</span>
                      <span class="unit">kg</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      除脂肪量
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv1000(bodyComposition, 'bodyFatFreeMassInGrams') }}</span>
                      <span class="unit">kg</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      筋肉量
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv1000(bodyComposition, 'muscleMassInGrams') }}</span>
                      <span class="unit">kg</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      筋肉スコア
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv(bodyComposition, 'muscleScore') }}</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      体水分量
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv1000(bodyComposition, 'bodyWaterMassInGrams') }}</span>
                      <span class="unit">kg</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      体内年齢
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv(bodyComposition, 'bodyAge') }}</span>
                      <span class="unit">才</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      推定骨量
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv1000(bodyComposition, 'boneMassInGrams') }}</span>
                      <span class="unit">kg</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      基礎代謝量
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv(bodyComposition, 'basalMetabolismInKcal') }}</span>
                      <span class="unit">kcal</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      内臓脂肪レベル
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv(bodyComposition, 'offalFatLevel') }}</span>
                      <span class="unit"></span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      BMI
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv(bodyComposition, 'bodyMassIndex') }}</span>
                      <span class="unit"></span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      標準体重
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv1000(bodyComposition, 'standardWeightInGrams') }}</span>
                      <span class="unit">kg</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      肥満度
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ vv(bodyComposition, 'bodyFatness') }}</span>
                      <span class="unit">%</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="mealsTime">
                    <span class="label">
                      測定日時
                    </span>
                    <span v-if="dailyEnquete.bodyCompositions">
                      <span class="val">{{ formatDateTime(bodyComposition, 'measurementTimeInMilliseconds') }}</span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </div>
          </div>
        </b-card>
        <b-card no-body id="others">
          <div slot="header"><i class="fas fa-tachometer-alt"></i> その他測定</div>
          <b-list-group flush>
            <b-list-group-item>
              <div v-if="editing === 'bodyTemperature'">
                <b-form-group>
                  <b-input-group prepend="体温">
                    <b-form-input
                                id="bodyTemperature"
                                type="number"
                                size="md"
                                v-model="form.bodyTemperature"
                                :state="validators.bodyTemperature"
                                required
                                placeholder="℃">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('bodyTemperature')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="bodyTemperatureFeedback">
                      体温を入力してください.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    <i class="fas fa-thermometer"></i>
                    体温
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('bodyTemperature')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.bodyTemperature">
                    <span class="val">{{ vv(dailyEnquete, 'bodyTemperature') }}</span>
                    <span class="unit">℃</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'bloodPressure'">
                <b-form-group>
                  <b-input-group prepend="血圧">
                    <b-form-input
                                id="bloodPressureSystolic"
                                type="number"
                                size="md"
                                v-model="form.bloodPressureSystolic"
                                :state="validators.bloodPressureSystolic"
                                required
                                placeholder="最高">
                    </b-form-input>

                    <b-form-input
                                id="bloodPressureDiastolic"
                                type="number"
                                size="md"
                                v-model="form.bloodPressureDiastolic"
                                :state="validators.bloodPressureDiastolic"
                                required
                                placeholder="最低">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('bloodPressureSystolic', 'bloodPressureDiastolic')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="bodyTemperatureFeedback">
                      血圧を入力してください.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    <i class="fas fa-heart"></i>
                    血圧
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('bloodPressure')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.bloodPressureSystolic">
                    <span class="val">{{ vv(dailyEnquete, 'bloodPressureSystolic') }} - {{ vv(dailyEnquete, 'bloodPressureDiastolic') }}</span>
                    <span class="unit"></span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'pulse'">
                <b-form-group>
                  <b-input-group prepend="脈拍">
                    <b-form-input
                                id="pulse"
                                type="number"
                                size="md"
                                v-model="form.pulse"
                                :state="validators.pulse"
                                required
                                placeholder="回/分">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('pulse')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="pulseFeedback">
                      脈拍を入力してください.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    <i class="fas fa-heartbeat"></i>
                    脈拍
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('pulse')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.pulse">
                    <span class="val">{{ vv(dailyEnquete, 'pulse') }}</span>
                    <span class="unit">回/分</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'boneDensity'">
                <b-form-group>
                  <span>骨量測定(判定) </span>
                  <b-form-select id="boneDensity"
                        v-model="form.boneDensity"
                        :validated="validators.boneDensity"
                        :options="boneDensityOptions"
                        name="radiosBtnDefault"
                        @change="onBoneDensityChanged">
                  </b-form-select>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    <i class="fas fa-bone"></i>
                    骨量測定(判定)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('boneDensity')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.boneDensity">
                    <span class="val">{{ vv(dailyEnquete, 'boneDensity') }}</span>
                    <span class="unit"></span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'boneDensityParcent'">
                <b-form-group>
                  <b-input-group prepend="骨量測定(対最大)">
                    <b-form-input
                                id="boneDensityParcent"
                                type="number"
                                size="md"
                                v-model="form.boneDensityParcent"
                                :state="validators.boneDensityParcent"
                                required
                                placeholder="%">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('boneDensityParcent')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="boneDensityParcentFeedback">
                      骨量測定(対最大)を入力してください.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    <i class="fas fa-bone"></i>
                    骨量測定(対最大)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('boneDensityParcent')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.boneDensityParcent">
                    <span class="val">{{ vv(dailyEnquete, 'boneDensityParcent') }}</span>
                    <span class="unit">%</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'bloodVesselAge'">
                <b-form-group>
                  <b-input-group prepend="血管年齢">
                    <b-form-input
                                id="bloodVesselAge"
                                type="number"
                                size="md"
                                v-model="form.bloodVesselAge"
                                :state="validators.bloodVesselAge"
                                required
                                placeholder="dV">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('bloodVesselAge')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="bloodVesselAgeFeedback">
                      血管年齢を入力してください.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    <i class="fas fa-bone"></i>
                    血管年齢
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('bloodVesselAge')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.bloodVesselAge">
                    <span class="val">{{ vv(dailyEnquete, 'bloodVesselAge') }}</span>
                    <span class="unit">dV</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-card no-body id="enquetes">
          <div slot="header"><i class="fas fa-tachometer-alt"></i> アンケート</div>
          <b-list-group flush>
            <b-list-group-item>
              <div v-if="editing === 'enquete1'">
                <b-form-group>
                  <b-input-group prepend="問1(1)">
                    <b-form-input
                                id="enquete1"
                                type="number"
                                size="md"
                                v-model="form.enquete1"
                                :state="validators.enquete1"
                                required
                                placeholder="1または2">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('enquete1')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="enquete1Feedback">
                      回答を入力してください
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    問1(1)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('enquete1')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.enquete1">
                    <span class="val">{{ vv(dailyEnquete, 'enquete1') }}</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'enquete2'">
                <b-form-group>
                  <b-input-group prepend="問1(2)">
                    <b-form-input
                                id="enquete2"
                                type="number"
                                size="md"
                                v-model="form.enquete2"
                                :state="validators.enquete2"
                                required
                                placeholder="1-5">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('enquete2')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="enquete2Feedback">
                      回答を入力してください
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    問1(2)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('enquete2')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.enquete2">
                    <span class="val">{{ vv(dailyEnquete, 'enquete2') }}</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'enquete3'">
                <b-form-group>
                  <b-input-group prepend="問2(3)">
                    <b-form-input
                                id="enquete3"
                                type="number"
                                size="md"
                                v-model="form.enquete3"
                                :state="validators.enquete3"
                                required
                                placeholder="1-3">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('enquete3')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="enquete3Feedback">
                      回答を入力してください
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    問2(3)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('enquete3')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.enquete3">
                    <span class="val">{{ vv(dailyEnquete, 'enquete3') }}</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'enquete4'">
                <b-form-group>
                  <b-input-group prepend="問2(4)">
                    <b-form-input
                                id="enquete1"
                                type="number"
                                size="md"
                                v-model="form.enquete4"
                                :state="validators.enquete4"
                                required
                                placeholder="1または2">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('enquete4')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="enquete4Feedback">
                      回答を入力してください
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    問2(4)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('enquete4')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.enquete4">
                    <span class="val">{{ vv(dailyEnquete, 'enquete4') }}</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'enquete5'">
                <b-form-group>
                  <b-input-group prepend="問2(5)">
                    <b-form-input
                                id="enquete5"
                                type="number"
                                size="md"
                                v-model="form.enquete5"
                                :state="validators.enquete5"
                                required
                                placeholder="1-3">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('enquete5')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="enquete5Feedback">
                      回答を入力してください
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    問2(5)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('enquete5')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.enquete5">
                    <span class="val">{{ vv(dailyEnquete, 'enquete5') }}</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'enquete6'">
                <b-form-group>
                  <b-input-group prepend="問2(6)">
                    <b-form-input
                                id="enquete6"
                                type="number"
                                size="md"
                                v-model="form.enquete6"
                                :state="validators.enquete6"
                                required
                                placeholder="1-4">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('enquete6')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="enquete6Feedback">
                      回答を入力してください
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    問2(6)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('enquete6')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.enquete1">
                    <span class="val">{{ vv(dailyEnquete, 'enquete6') }}</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'enquete7'">
                <b-form-group>
                  <b-input-group prepend="問2(7)">
                    <b-form-input
                                id="enquete7"
                                type="number"
                                size="md"
                                v-model="form.enquete7"
                                :state="validators.enquete7"
                                required
                                placeholder="1-3">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('enquete7')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="enquete7Feedback">
                      回答を入力してください
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    問2(7)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('enquete7')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.enquete7">
                    <span class="val">{{ vv(dailyEnquete, 'enquete7') }}</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'enquete8'">
                <b-form-group>
                  <b-input-group prepend="問2(8)">
                    <b-form-input
                                id="enquete8"
                                type="number"
                                size="md"
                                v-model="form.enquete8"
                                :state="validators.enquete8"
                                required
                                placeholder="1または2">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('enquete8')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="enquete8Feedback">
                      回答を入力してください
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    問2(8)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('enquete8')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.enquete8">
                    <span class="val">{{ vv(dailyEnquete, 'enquete8') }}</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="editing === 'enquete9'">
                <b-form-group>
                  <b-input-group prepend="問3(9)">
                    <b-form-input
                                id="enquete9"
                                type="number"
                                size="md"
                                v-model="form.enquete9"
                                :state="validators.enquete9"
                                required
                                placeholder="1または2">
                    </b-form-input>
                    <b-input-group-append>
                      <b-btn variant="success" @click="editDailyEnquetes('enquete9')"><i class="fas fa-save"></i></b-btn>
                      <b-btn variant="outline-secondary" @click="editing = null"><i class="fas fa-times-circle"></i></b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="enquete9Feedback">
                      回答を入力してください
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
              <div v-else>
                <div class="mealsTime">
                  <span class="label">
                    問3(9)
                  </span>
                  <span><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('enquete9')"><i class="fas fa-edit" /></b-btn></span>
                  <span v-if="dailyEnquete.enquete9">
                    <span class="val">{{ vv(dailyEnquete, 'enquete9') }}</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-card no-body>
          <div slot="header">
            <i class="fas fa-weight"></i> コメント
            <span v-if="editing !== 'comments'"><b-btn size="sm" variant="success" @click="onDailyEnquetesEdit('comments')"><i class="fas fa-edit" /></b-btn></span>
          </div>
          <b-list-group flush>
            <b-list-group-item>
              <div v-if="editing === 'comments'">
                <b-form-textarea id="textarea2"
                   v-model.trim="form.comments"
                   placeholder="コメント"
                   :rows="3"></b-form-textarea>
                <b-btn variant="success" block   @click="editDailyEnquetes('comments')"><i class="fas fa-save"></i></b-btn>
              </div>
              <div v-else>
                <pre class="p-2 border comments" @click="onDailyEnquetesEdit('comments')">{{ dailyEnquete.comments }}</pre>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-card no-body header="これまでに参加した測定会">
          <b-list-group flush>
            <b-list-group-item v-for="de in dailyEnquetes" :key="de.calendarTime">
              <b-link :href="link(de)">{{formatDate(de.userGroup, 'scheduledAtDate')}} {{ de.userGroup.name }}</b-link>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-card-group>
    </div>
    <hr>
    <div class="p-2 border-bottom border-info">
      <b-btn variant="danger" @click="onLeaveConfirm"><i class="fas fa-trash-alt"/> 参加取消</b-btn>
    </div>
    <div class="mb-2">
      <b-btn variant="secondary" block @click="$router.push('/usergroups/' + $store.getters.currentUserGroup.groupId + '/top')">
        <span>戻る</span>
      </b-btn>
    </div>
    <div>
      <b-modal centered ref="leaveModal" title="参加取消確認" @ok="leaveUserGroup">
        <p>この参加者({{userSettings && userSettings.userNo}})を参加取り消ししますか？</p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { Logger } from 'aws-amplify'
import moment from 'moment-timezone'
import NumberUtils from '@/utils/NumberUtils'

const logger = new Logger('UserDisplay')

export default {
  name: 'UserDisplay',
  data () {
    return {
      loading: false,
      message: null,
      error: null,
      userId: null,
      groupId: null,
      userSettings: null,
      dailyEnquete: {},
      dailyEnquetes: [],
      bodyComposition: {},
      bodyCompositions: [],
      editing: null,
      form: {
        heightInCentimeters: null,
        gender: null,
        physicalType: null,
        weightAdjustmentInKilograms: null,
        bodyTemperature: null,
        bloodPressureDiastolic: null,
        bloodPressureSystolic: null,
        boneDensity: null,
        boneDensityParcent: null,
        enquete1: null,
        enquete2: null,
        enquete3: null,
        enquete4: null,
        enquete5: null,
        enquete6: null,
        enquete7: null,
        enquete8: null,
        enquete9: null,
        comments: null
      },
      validators: {
        heightInCentimeters: null,
        gender: null,
        physicalType: null,
        weightAdjustmentInKilograms: null,
        bodyTemperature: null,
        bloodPressureDiastolic: null,
        bloodPressureSystolic: null,
        boneDensity: null,
        boneDensityParcent: null,
        enquete1: null,
        enquete2: null,
        enquete3: null,
        enquete4: null,
        enquete5: null,
        enquete6: null,
        enquete7: null,
        enquete8: null,
        enquete9: null,
        comments: null
      },
      genderOptions: [
        { text: '男性', value: '1' },
        { text: '女性', value: '2' }
      ],
      boneDensityOptions: [
        { text: '選択', value: null },
        { text: '1', value: '1' },
        { text: '2', value: '2' },
        { text: '3', value: '3' },
        { text: '4', value: '4' },
        { text: '5', value: '5' }
      ],
      physicalTypeOptions: [
        { text: '標準', value: '0' },
        { text: 'アスリート', value: '2' }
      ]
    }
  },
  computed: {
    currentUserGroup () {
      return this.$store.getters.currentUserGroup || {}
    }
  },
  mounted () {
    this.loadItems()
  },
  methods: {
    vv (bc, key) {
      return bc[key]
    },
    vv100 (bc, key) {
      return NumberUtils.formatNumber(bc[key] / 100, 1)
    },
    vv1000 (bc, key) {
      return NumberUtils.formatNumber(bc[key] / 1000, 1)
    },
    formatDate (bc, key) {
      return moment(bc[key]).format('YY/MM/DD')
    },
    formatDateTime (bc, key) {
      return moment(bc[key], 'x').format('YY/MM/DD HH:mm')
    },
    loadItems (done) {
      this.groupId = this.$route.params['groupId']
      this.userId = this.$route.params['userId']
      logger.debug(this.$route.params)
      this.loading = true
      this.message = null
      this.error = null
      this.$store.dispatch('getUserGroup', { groupId: this.groupId }).then((userGroup) => {
        logger.debug('userGroup=', userGroup)
        this.$store.commit('setCurrentUserGroup', { userGroup })

        return this.$store.dispatch('fetchUser', { userId: this.userId }).then((user) => {
          logger.debug('user: ', user)
          // this.$store.commit('setCurrentUser', { user })
          this.userSettings = user
          return user
        })
      }).then(user => {
        if (!user) {
          throw new Error('ID番号が見つかりません')
        }
        return this.$store.dispatch('findUserDailyEnquetes', { userId: this.userId }).then(dailyEnquetes => {
          this.dailyEnquetes = dailyEnquetes || []
          this.dailyEnquete = this.dailyEnquetes.find(de => de.userGroupId === this.currentUserGroup.groupId) || {}
          this.bodyComposition = this.dailyEnquete && this.dailyEnquete.bodyCompositions
          return dailyEnquetes
        })
      }).then(data => {
        this.loading = false
        done && done()
      }).catch((error) => {
        this.loading = false
        logger.error(error)
        this.error = '通信エラーが発生しました。'
        this.error += error.message
      })
    },
    refreshItem () {
      this.loadItems()
    },
    link (userdailyEnquetes) {
      return '/usergroups/' + userdailyEnquetes.userGroupId + '/users/' + this.userSettings.user_id
    },
    onMeasureSet () {
      if (!this.currentUserGroup.idms || this.currentUserGroup.idms.length < 1) {
        this.error = 'FeliCaカードが登録されていません'
        return
      }
      this.loading = true
      this.message = null
      this.error = null
      for (let idm of this.currentUserGroup.idms) {
        this.$store.dispatch('updateUserFelica', { idm: idm, user: this.userSettings }).then(() => {
          this.loading = false
          this.message = '体測定計の準備ができました。FeliCaカードをかざして、測定を開始してください。'
        }).catch((error) => {
          this.loading = false
          logger.error(error)
          this.error = '通信エラーが発生しました。'
          this.error += error.message
        })
      }
    },
    onUserEdit (name) {
      this.editing = name
      this.form.heightInCentimeters = this.userSettings.heightInCentimeters
      this.form.gender = this.userSettings.gender
      this.form.physicalType = this.userSettings.physicalType
      this.form.weightAdjustmentInKilograms = this.userSettings.weightAdjustmentInKilograms
    },
    getValidator (name) {
      return {
        'heightInCentimeters': function (value) { return value && (value >= 90 && value < 249) },
        'gender': function (value) { return value && (value === '1' || value === '2') },
        'physicalType': function (value) { return value && (value === '0' || value === '2') },
        'weightAdjustmentInKilograms': function (value) { return value && (value >= 0 && value <= 10) },
        'bodyTemperature': function (value) { return !value || (value >= 34 && value <= 45) },
        'bloodPressureDiastolic': function (value) { return !value || (value >= 0 && value <= 300) },
        'bloodPressureSystolic': function (value) { return !value || (value >= 0 && value <= 300) },
        'pulse': function (value) { return !value || (value >= 0 && value <= 300) },
        'boneDensity': function (value) { return true },
        'boneDensityParcent': function (value) { return true },
        'bloodVesselAge': function (value) { return !value || (value >= 0 && value <= 300) },
        'enquete1': function (value) { return true },
        'enquete2': function (value) { return true },
        'enquete3': function (value) { return true },
        'enquete4': function (value) { return true },
        'enquete5': function (value) { return true },
        'enquete6': function (value) { return true },
        'enquete7': function (value) { return true },
        'enquete8': function (value) { return true },
        'enquete9': function (value) { return true },
        'comments': function (value) { return true }
      }[name]
    },
    editUser (name) {
      this.validators[name] = this.getValidator(name)(this.form[name])
      logger.debug(name, this.validators[name])
      if (!this.validators[name]) {
        return
      }
      this.loading = true
      this.message = null
      this.error = null
      this.$store.dispatch('updateUser', { userId: this.userSettings.user_id, name: name, value: this.form[name] }).then(user => {
        this.loading = false
        this.editing = null
        this.message = '更新しました'
        this.userSettings[name] = this.form[name]
      }).catch((error) => {
        this.loading = false
        logger.error(error)
        this.error = '通信エラーが発生しました。'
        this.error += error.message
      })
    },
    onBoneDensityChanged (newValue) {
      this.form.boneDensity = newValue
      this.editDailyEnquetes('boneDensity')
    },
    onBoneDensityParcentChanged (newValue) {
      this.form.boneDensityParcent = newValue
      this.editDailyEnquetes('boneDensityParcent')
    },
    onDailyEnquetesEdit (name) {
      this.editing = name
      if (name === 'bloodPressure') {
        this.form['bloodPressureSystolic'] = this.dailyEnquete['bloodPressureSystolic']
        this.form['bloodPressureDiastolic'] = this.dailyEnquete['bloodPressureDiastolic']
      } else {
        this.form[name] = this.dailyEnquete[name]
      }
    },
    editDailyEnquetes (...names) {
      let vs = names.map(name => {
        this.validators[name] = this.getValidator(name)(this.form[name])
        return this.validators[name]
      }).every(v => v)
      logger.debug(names, this.form)
      if (!vs) return

      let values = names.map(name => { return { name: name, value: this.form[name] } })
      logger.debug(values)
      if (names[0] === 'comments') {
        values = [{ name: 'comments', value: (this.form['comments'] === '' ? ' ' : this.form['comments']) }]
      }
      logger.debug(values)

      this.loading = true
      this.message = null
      this.error = null
      this.$store.dispatch('editUserDailyEnquetes', {
        userId: this.userSettings.user_id, calendarTime: this.dailyEnquete.calendarTime, values
      }).then(() => {
        this.loading = false
        this.editing = null
        this.message = '更新しました'
        names.forEach(name => {
          this.dailyEnquete[name] = this.form[name]
        })
      }).catch((error) => {
        this.loading = false
        logger.error(error)
        this.error = '通信エラーが発生しました。'
        this.error += error.message
      })
    },
    onLeaveConfirm () {
      this.$refs.leaveModal.show()
    },
    leaveUserGroup () {
      this.loading = true
      this.message = null
      this.error = null
      this.$store.dispatch('deleteUserDailyEnquetes', { userId: this.userSettings.user_id, calendarTime: this.currentUserGroup.scheduledAt }).then(() => {
        return this.$store.dispatch('leaveUserGroup', {
          userGroup: this.currentUserGroup, userId: this.userSettings.user_id })
      }).then(() => {
        return this.$store.dispatch('removeUserGroup', {
          userSettings: this.userSettings, groupId: this.currentUserGroup.groupId
        })
      }).then(() => {
        this.loading = false
        this.message = '参加取消しました'
        this.$refs.leaveModal.hide()
        this.$router.push('/usergroups/' + this.currentUserGroup.groupId + '/members')
      }).catch((error) => {
        this.loading = false
        logger.error(error)
        this.error += error.message
      })
    }
  }
}
</script>
<style>
.mealsTime span.val {
  font-weight: 800;
  font-size: 20px;
}
.comments {
  min-height: 3em;
}
.list-group-item button.btn {
  margin-right: 0.5em;
}
</style>
